import { OptionType, StationFilterOption } from '@app/components/stations/advanced-filter/types';
import { auditReports } from '@mi-front/api-clients';
import { DateTimeStr, Station } from '@mi-front/core';
import moment from 'moment';
import { GipReportValues } from '../form/types';
import { areDatesDisabledForReport } from './helpers';

export function mapValuesToGipReportDataDto(
  clientId: string,
  values: GipReportValues,
  stations: readonly Station[],
): auditReports.GipReportDataDto {
  const datesDisabled = areDatesDisabledForReport(values);

  function transformDateWithoutTz(date: string): DateTimeStr {
    return new Date(date).toLocaleString('sv').replace(' ', 'T') as DateTimeStr;
  }

  const useFullDateRange = datesDisabled && !values._fixedDateRange;

  // Handle station selection based on selection type
  let stationsIds: string[] | undefined;
  let stationsFilters: auditReports.GipReportDataDto['stationsFilters'] | undefined;

  if (values.stationsSelectionType === 'advanced') {
    // Use advanced filtering
    stationsFilters =
      values.stationsFilter?.map((filter: StationFilterOption) => {
        switch (filter.type) {
          case OptionType.StationType:
            return {
              type: auditReports.StationsFiltersTypeEnum.STATION_TYPE,
              value: filter.value,
            };
          case OptionType.StationGroup:
            return {
              type: auditReports.StationsFiltersTypeEnum2.STATION_GROUP,
              value: filter.value.id,
            };
          case OptionType.IndividualStation:
            return {
              type: auditReports.StationsFiltersTypeEnum3.STATION_INDIVIDUAL,
              value: filter.value.id,
            };
          default:
            throw new Error(`Unknown station filter type: ${JSON.stringify(filter)}`);
        }
      }) ?? [];
  } else {
    // Use simple station selection (fallback to all stations if none selected)
    stationsIds = (values.stations?.length ? values.stations : stations).map((s) => s.id);
  }

  return {
    clientId,
    stationsIds,
    stationsFilters,
    from: useFullDateRange
      ? ('2020-01-01T00:00:00Z' as DateTimeStr)
      : transformDateWithoutTz(values.from),
    to: useFullDateRange
      ? (moment().endOf('day').toISOString() as DateTimeStr)
      : transformDateWithoutTz(values.to),
    campaigns: values.campaigns.map((v) => v.name),
    advertisers: values.advertisers.map((v) => v.name),
    versions: values.versions.map((v) => v.name),
    customFields: values.customFieldKey
      ? {
          [values.customFieldKey.name]: values.customFieldValue,
        }
      : {},
    customIds: values.customIds.map((v) => v.customId),
    orders: values.orders,
    excludedMatches: values.excludedMatches,
  };
}
